import { HeroCardBody } from './HeroCardBody';
import { HeroCardCtas } from './HeroCardCtas';
import { HeroCardOnlineTab } from './HeroCardOnlineTab';
import { HeroCardPanel } from './HeroCardPanel';
import { HeroCardPostCta } from './HeroCardPostCta';
import { HeroCardTabs } from './HeroCardTabs';
import { resolveHeroCardTabbedCity } from './resolveHeroCard';
import type { HeroCardTabbedCityConfig, HeroCardRootProps } from './types';
import { Text } from '@/lib/render/Text';

export interface HeroCardTabbedCityProps extends HeroCardRootProps {
  config: HeroCardTabbedCityConfig;
}

/**
 * The city page's tabbed card. Tab 1 ("Nachhilfe vor Ort") is exactly the Text
 * card's body shape — a title, one rich-text field carrying both the intro
 * paragraph and the checkmark bullets, and stacked CTAs. Tab 2 is the shared
 * "Nachhilfe Online" body, identical to the Home card's.
 */
export function HeroCardTabbedCity({
  config,
  ...rest
}: HeroCardTabbedCityProps) {
  const resolved = resolveHeroCardTabbedCity(config);

  return (
    <HeroCardTabs
      tabOneLabel={resolved.tabOneLabel}
      tabOneAnchor={resolved.tabOneAnchor}
      tabTwoLabel={resolved.tabTwo.label}
      tabTwoAnchor={resolved.tabTwo.anchor}
      preselectedTab={resolved.preselectedTab}
      {...rest}
      renderTabOne={() => (
        <HeroCardPanel roundedTop={false}>
          {resolved.tabOneTitle && (
            <Text
              as="h2"
              field="tabOneTitle"
              className="text-secondary text-sm leading-snug font-medium md:text-lg md:leading-[1.1667]"
            >
              {resolved.tabOneTitle}
            </Text>
          )}
          <HeroCardBody nodes={resolved.tabOneBody} />
          <HeroCardCtas actions={resolved.tabOneCtas} />
          <HeroCardPostCta postCta={resolved.tabOnePostCta} />
        </HeroCardPanel>
      )}
      renderTabTwo={() => (
        <HeroCardPanel roundedTop={false}>
          <HeroCardOnlineTab tab={resolved.tabTwo} />
        </HeroCardPanel>
      )}
    />
  );
}
